import { fetchWrapper } from "@/helpers/fetch-wrapper";
// import { useUserActivityFiltersStore } from "@/stores/userActivityFilters";

/**
 * Serwis do operacji na użytkownikach, aktywnościach i uprawnieniach.
 */
class Roles {

    /**
     * Tworzy query string na podstawie filtrów (np. wyszukiwarka użytkowników, aktywności).
     * Pobiera filtry z store, buduje parametry GET.
     */
    // getQueryString() {
    //     const filtersStore = useUserActivityFiltersStore();
    //     const keys = filtersStore && filtersStore.filters ? Object.keys(filtersStore.filters) : [];

    //     // Generuje query string na podstawie kluczy i wartości filtrów (pomija puste)
    //     return keys.length > 0 
    //       ? '&' + keys
    //         .map((key) => (filtersStore.filters[key] && (filtersStore.filters[key].length > 0 || filtersStore.filters[key] > 0)) 
    //             ? key + "=" + filtersStore.filters[key] : '')
    //         .join("&") 
    //       : '';
    // }
    
    /**
     * Zwraca wybrany typ zdarzeń (eventTypes) z filtra aktywności użytkownika.
     */
    // getEventTypes() {
    //     const filtersStore = useUserActivityFiltersStore();
    //     return filtersStore?.filters?.eventTypes ?? null;
    // }

    /**
     * Pobiera listę roli z API (wszystkich, sortowanych rosnąco).
     */
    getRoleList() {
        return fetchWrapper.getWithCount(`${process.env.VUE_APP_API_URL}/roles?orderDirection=asc`);
    }

    /**
     * Pobiera listę aktywności użytkowników lub logów VMS, zależnie od typu zdarzenia.
     * - eventType == null lub <3: normalne logowania do stacji,
     * - eventType == 3: logi VMS (inne API, inny endpoint).
     */
    // getUserActivityList(pageNum, pageSize) {
    //     const eventType = this.getEventTypes();
    //     let queryString = this.getQueryString();

    //     if (eventType == null) {
    //         // Brak wybranego eventType pobiera logowania
    //         return fetchWrapper.getWithCount(
    //             `${process.env.VUE_APP_API_URL}/login-to-locations?orderDirection=desc&page=${pageNum}&limit=${pageSize}` + queryString
    //         );
    //     }
    //     if (eventType == 3) {
    //         // Wybrane VMS pobiera logi VMS, ucina niepotrzebny fragment zapytania (?)
    //         queryString = queryString.slice(0, -12);
    //         let response = fetchWrapper.getWithCount(
    //             `${process.env.VUE_APP_API_URL}/vms-logs?orderDirection=desc&` + queryString
    //         );
    //         // Debug info
    //         // console.log('getActivityList response:' + JSON.stringify(response));
    //         return response;
    //     }
    //     if (eventType < 3) {
    //         // Pozostałe typy zdarzeń zwykłe logowania
    //         return fetchWrapper.getWithCount(
    //             `${process.env.VUE_APP_API_URL}/login-to-locations?orderDirection=desc&page=${pageNum}&limit=${pageSize}` + queryString
    //         );
    //     }
    // }

    /**
     * Dodaje nowego użytkownika (POST).
     * @param {Object} objectData - dane użytkownika
     */
    addRole(objectData) {
        return fetchWrapper.post(`${process.env.VUE_APP_API_URL}/roles`, objectData);
    }

    /**
     * Pobiera group po ID.
     */
    fetchRole(id) {
        return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/roles/${id}`);
    }

    /**
     * Aktualizuje użytkownika po ID (PUT).
     * @param {Number} id - ID użytkownika
     * @param {Object} userData - nowe dane
     */
    updateRole(id, roleData) {
        return fetchWrapper.put(`${process.env.VUE_APP_API_URL}/roles/${id}`, roleData);
    }

    /**
     * Usuwa użytkowników (bulk delete przez POST).
     * @param {Array} ids - tablica ID do usunięcia
     */
    deleteRoles(ids) {
        return fetchWrapper.post(`${process.env.VUE_APP_API_URL}/roles/bulk-delete`, ids);
    }

    /**
     * Pobiera listę ról dostępnych w systemie (do formularzy, dropdownów, uprawnień).
     */
    getRolesList() {
        return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/roles`);
    }

    /**
     * Pobiera pełny katalog dostępnych uprawnień (access.role) — także tych jeszcze nieprzypisanych
     * do żadnej grupy (np. nowo dodane ROLE_10). Zwraca tablicę obiektów { id, name, description }.
     */
    getAllPermissions() {
        return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/permissions`);
    }

    /**
     * Pobiera raport logowań użytkowników w zadanym zakresie dat (ZIP, CSV).
     */
    // getZip(dateFrom, dateTo) {
    //     return fetchWrapper.get(
    //         `${process.env.VUE_APP_API_URL}/login-to-locations/report` +
    //         `?dateTimeStart=${dateFrom}&dateTimeEnd=${dateTo}` + this.getQueryString()
    //     );
    // }

    /**
     * Pobiera plik (np. ZIP, CSV, PDF) jako blob (do pobrania).
     */
    // fetch(zip) {
    //     let zipNoStart = zip.includes('api/v1') ? zip.substr(7) : zip;
    //     return fetchWrapper.getBlob(process.env.VUE_APP_API_URL + zipNoStart);
    // }

    /**
     * Pobiera własny token do API.
     */
    // getSelfToken() {
    //     return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users/self/token`);
    // }

    /**
     * Dodaje użytkownika do systemu  (helpdesk) przez API.
     * Wymaga tokena autoryzacyjnego.
     */
    // async addGroupTo(objectData, token) {
    //     return await fetch('https://support.cat-traffic.pl/api/v1/users', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': 'Bearer ' + token,
    //         },
    //         body: JSON.stringify(objectData),
    //     })
    //     .then((response) => {
    //         if (!response.ok) {
    //             console.error('Błąd przy dodawaniu użytkownika do :', response.status, response.statusText);
    //             throw new Error(`HTTP error! status: ${response.status}`);
    //         }
    //         return response.json();
    //     })
    //     .catch((error) => {
    //         console.error('Wystąpił błąd:', error);
    //     });
    // }
    
    /**
     * Tworzy token API w  dla użytkownika.
     * Zwraca fetch z POST na endpoint user_access_token.
     */
    // generateToken(login, password) {
    //     let token = btoa(login + ':' + password); // Kodowanie Basic Auth
    //     let expiresAt = new Date();
    //     expiresAt.setFullYear(expiresAt.getFullYear() + 2);
    //     let expiresAtString = expiresAt.toISOString().split('T')[0];

    //     let data = {
    //         name: login,
    //         permission: ['ticket.customer', 'ticket.agent'],
    //         expires_at: expiresAtString,
    //     };
    
    //     let result = fetch('https://support.cat-traffic.pl/api/v1/user_access_token', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': 'Basic ' + token,
    //         },
    //         body: JSON.stringify(data),
    //     });

    //     return result;
    // }

    /**
     * Zapisuje token do bazy w systemie (użytkownik + token).
     */
    // saveTokenToDatabase(token, email) {
    //     return fetchWrapper.post(
    //         `${process.env.VUE_APP_API_URL}/users/self/token/save`, 
    //         { token, email }
    //     )
    //     .then((data) => data)
    //     .catch((error) => {
    //         console.error("Error saving token:", error);
    //         throw error;
    //     });
    // }

    /**
     * Pobiera listę organizacji z  (helpdesk) - API.
     */
    // async getOrganizations(token) {
    //     try {
    //       const response = await fetch('https://support.cat-traffic.pl/api/v1/organizations', {
    //         method: 'GET',
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'Authorization': 'Bearer ' + token,
    //         },
    //       });
      
    //       if (!response.ok) {
    //         throw new Error(`HTTP error! Status: ${response.status}`);
    //       }
      
    //       const data = await response.json();
    //       return data;
    //     } catch (err) {
    //       console.error("Error in getOrganizations:", err);
    //       throw err;
    //     }
    // }
}

// Eksport singletonu serwisu
export default new Roles();
